import Alert from 'antd/lib/alert';
import React from 'react';

const PopupCheckerComponent = () => {
    return (
        <div style={{ padding: 20 }}>
            <Alert
                message={`Pop-up disabled`}
                description={<div>You may close this page and continue.</div>}
                type="info"
                showIcon
            />
        </div>
    );
};

export default PopupCheckerComponent;
